// extracted by mini-css-extract-plugin
export default {"App":"App_App__h9Bw5","App-logo":"App_App-logo__aWS14","App-logo-spin":"App_App-logo-spin__bdhkA","App-header":"App_App-header__bvz7U","App-link":"App_App-link__ZKc1q"};